import React from 'react';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import {i18nInit} from 'root/internationalization/config';

const RatingScaleLegend = ({show,onClose,onOpen,data}) => {
    let ratingScaleData = [...data];
    ratingScaleData.sort((a,b) => {
        if (a.RATING_NR < b.RATING_NR) return -1;
        if (a.RATING_NR > b.RATING_NR) return 1;
        return 0;
    });
    return (
        <SwipeableDrawer
            anchor="bottom"
            open={show}
            onClose={onClose}
            onOpen={onOpen}
        >
            <div className="rating-legend">
                <div tabIndex="0" aria-label={i18nInit.t("lbl.LEGEND")} className="rating-legend__title">{i18nInit.t("lbl.LEGEND")}</div>
                <div className="rating-legend__content">
                    {data.map((val)=>{
                        return (
                            <span className="rating-legend__item" key={val.RATING_VALUE}>
                                <span tabIndex={0} aria-label={val.RATING_VALUE - val.RATING_DESC} className="rating-legend__item-desc">{val.RATING_VALUE}. <strong>{val.RATING_DESC}</strong></span>
                                {val.RATING_DESCRIPTOR == "" &&
                                    <span className="rating-legend__item-descriptor">{val.RATING_DESCRIPTOR}</span>
                                }
                            </span>);
                    })}
                </div>
            </div>
        </SwipeableDrawer>
    )
};

export default RatingScaleLegend;





